import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <header className="bg-white shadow-sm">
      <nav className="container mx-auto px-4 py-4 flex justify-between items-center">
        <Link to="/" className="text-xl font-bold text-gray-800">Your Company</Link>
        <ul className="flex space-x-4">
          <li><Link to="/about" className="text-gray-600 hover:text-gray-800">About</Link></li>
          <li><Link to="/pricing" className="text-gray-600 hover:text-gray-800">Pricing</Link></li>
          <li><Link to="/contact" className="text-gray-600 hover:text-gray-800">Contact</Link></li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;

